export * from "./capi.mjs";
export const Vue2 = void 0;
export const isVue2 = false;
export const isVue3 = true;
